import {
  faClock,
  faGlobe,
  faMapMarkerAlt,
  faPhone,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState, useEffect } from 'react'

const GPCard = ({
  gp,
  marker,
  onChoose,
  onViewDetails,
  idx,
  gpCardRefs,
  setSelectedMarker,
  isOpen,
}) => {
  return (
    <div
      key={idx}
      ref={gpCardRefs?.current[idx]}
      className="p-5 border rounded-xl shadow-sm bg-white space-y-4 transition-all duration-300"
    >
      <div className="flex flex-col sm:flex-row justify-between items-start">
        <div>
          <h3 className="text-lg font-bold">{marker?.name}</h3>
          <p className="text-gray-600 flex items-center gap-2">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="text-gray-500" />
            {gp?.address || 'Address not available'}
          </p>
        </div>

        <div className="flex flex-col gap-2 items-end mt-4 w-full sm:w-auto sm:mt-0">
          <button
            type="button"
            onClick={() => setSelectedMarker(isOpen ? null : idx)}
            className="w-full sm:w-56 h-12 px-6 py-3 bg-white border border-gray-300 rounded-md text-sm font-semibold hover:bg-gray-100 flex justify-center items-center"
          >
            {isOpen ? 'Hide Details' : 'View Details'}
          </button>
          <button
            onClick={() => onChoose(marker?.gp)}
            className="w-full sm:w-56 h-12 px-6 py-3 bg-[#7B5FA6] rounded-md text-sm font-bold hover:bg-[#DDCCDF] text-white flex justify-center items-center"
          >
            Choose GP
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="space-y-2 text-sm text-gray-700 mt-3 pt-3 border-t">
          {gp?.phone && (
            <div className="flex items-start gap-2">
              <FontAwesomeIcon icon={faPhone} className="text-gray-500" />
              <span>{gp?.phone}</span>
            </div>
          )}

          {gp?.website && (
            <div className="flex items-start gap-2">
              <FontAwesomeIcon icon={faGlobe} className="text-gray-500" />
              <a
                href={gp?.website}
                className="underline text-blue-600"
                target="_blank"
                rel="noopener noreferrer"
              >
                {gp?.website}
              </a>
            </div>
          )}

          {gp?.googleUrl && (
            <div className="flex items-start gap-2">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className="text-gray-500"
              />
              <a
                href={marker?.googleUrl}
                className="underline text-blue-600"
                target="_blank"
                rel="noopener noreferrer"
              >
                View on Google
              </a>
            </div>
          )}

          {gp?.hours?.weekday_text && (
            <div className="flex items-start gap-2 mt-6">
              <FontAwesomeIcon icon={faClock} className="text-gray-500" />
              <div className="space-y-1">
                {gp?.hours.weekday_text.map((line, index) => (
                  <p key={index} className="text-sm text-gray-700">
                    {line}
                  </p>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default GPCard
